<div class="dashboard-container" [class.paddingLeft]="isSidebarExpanded">
    <div class="p-4">
        <div class="header mb-3 d-flex justify-content-between align-items-center flex-wrap">

            <div class="d-flex align-items-center gap-5 flex-wrap">
                <div class="member-board-title">
                    <p class="fw-500 mb-2 fs-17 mb-0">Applicants Board</p>
                    <span class="text-muted small">Overview of medical evidence requests and submissions</span>
                </div>

                <div class="team-avatars">
                    <ng-container *ngFor="let member of displayedTeamMembers; let i = index">
                        <div class="avatar-initials"
                            [class.active-avatar-highlight]="showedUserSelected === member.userId"
                            [class]="getAvatarColorClass(i)" matTooltip="{{ getAssignedAgentFullName(member) }}"
                            matTooltipPosition="below" [style.animation-delay]="i * 0.1 + 's'"
                            (click)="onAvatarClick(member,'user')">
                            {{ getInitials(member) }}
                        </div>
                    </ng-container>


                    <div class="remaining-members-count" (click)="togglePopover()" *ngIf="remainingMembersCount > 0">
                        &nbsp; +{{ remainingMembersCount }} Agents
                    </div>

                    <div class="agent-popover" *ngIf="showPopover" [ngClass]="{
                            'circle-layout': hiddenAgents.length <= 10 && hiddenAgents.length > 4,
                            'grid-layout': hiddenAgents.length > 10 || hiddenAgents.length < 4
                        }">
                        <div class="avatar-initials" *ngFor="let member of hiddenAgents; let i = index"
                            [ngStyle]="hiddenAgents.length <= 10 && hiddenAgents.length > 4 ? getCircularStyle(i, hiddenAgents.length) : {}"
                            [ngClass]="{
                                'active-avatar-highlight': activeMemberId === member.userId,
                                'purple': getAvatarColorClass(i) === 'purple',
                                'green-gradient': getAvatarColorClass(i) === 'green-gradient',
                                'blue': getAvatarColorClass(i) === 'blue'
                            }" matTooltip="{{ getAssignedAgentFullName(member) }}"
                            [style.animation-delay]="i * 0.1 + 's'" (click)="onAvatarClick(member,'user')">
                            {{ getInitials(member) }}
                        </div>
                    </div>
                </div>

                <div class="clearFilters" (click)="clearFilters()" *ngIf="showedUserSelected"
                    [class.applyMarginLeft]="showPopover">
                    Clear filters
                </div>

                <div class="quick-filters-wrapper" *ngIf="!activeMemberId">

                    <div class="clearFilters" [class.applyMarginLeftQuick]="showPopover" (click)="toggleQuickFilters()"
                        *ngIf="!showPopover">
                        Quick filters
                    </div>

                    <div *ngIf="showQuickFilters" class="quick-filters-panel">

                        <!-- Header Row with Radio Button and Close Icon -->
                        <div class="quick-filters-header d-flex justify-content-between align-items-center mb-2">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="filterOption" value="me"
                                    [(ngModel)]="selectedOption" id="assignedToMe"
                                    (click)="onSelfClick();$event.stopPropagation()">
                                <label class="fs-12" for="assignedToMe">&nbsp; Assigned to me</label>
                            </div>

                            <div class="quick-filters-close" (click)="onCloseQuickFilter()">
                                &times;
                            </div>
                        </div>

                        <!-- Second Radio Button with Search -->
                        <div>
                            <div class="w-100">
                                <mat-form-field appearance="outline" class="search-field-agent">
                                    <span matPrefix style="display: flex; align-items: center; margin-left: 8px;">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"
                                            stroke-linecap="round" stroke-linejoin="round">
                                            <path
                                                d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314" />
                                        </svg>
                                    </span>
                                    <input matInput placeholder="Search Agents" (click)="$event.stopPropagation()"
                                        [(ngModel)]="searchAgent" (input)="onAgentSearch()" />
                                </mat-form-field>
                            </div>

                            <div *ngIf="filteredAgents.length > 0">
                                <div class="user-list-scroll scroll-content mt-2">
                                    <div class="user-card" *ngFor="let user of filteredAgents; let i = index" [ngClass]="{
                        'selected': selectedUser === user.userId,
                        'border-bottom': selectedUser !== user.userId
                    }" (click)="selectUser(user)">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="d-flex align-items-center gap-2">
                                                <div class="avatar">
                                                    {{ user.firstName.charAt(0) }}{{ user?.lastName?.charAt(0) }}
                                                </div>
                                                <div class="user-details">
                                                    <div class="fw-500 fs-12">{{ user.firstName }} {{ user?.lastName
                                                        }}
                                                    </div>
                                                    <div class="text-muted fs-10">{{ user.phone }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div style="display: flex; align-items: center; gap: 12px;">
                <span class="cursor-pointer actionIcon" (click)="onRefresh()" matTooltip="refresh"
                    matTooltipPosition="above">
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24"
                        [ngClass]="{ 'rotate-animation': isRotating }">
                        <g fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.2">
                            <path
                                d="M6.446 10.512a5.75 5.75 0 0 0 8.429 6.468m2.679-3.492A5.75 5.75 0 0 0 9.125 7.02" />
                            <path stroke-linejoin="round" d="m3.75 12.5l2.5-2.5l2.5 2.5m6.5-1l2.5 2.5l2.5-2.5" />
                        </g>
                    </svg>
                </span>

                <div class="search-container" [class.expanded]="searchExpanded">
                    <span class="search-icon actionIcon" (click)="toggleSearch()" aria-label="Open search"
                        *ngIf="!searchExpanded" matTooltip="search by applicant" matTooltipPosition="above">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                            <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round"
                                d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314"
                                stroke-width="2" />
                        </svg>
                    </span>
                    <mat-form-field appearance="outline" class="search-field" *ngIf="searchExpanded">
                        <span matPrefix style="display: flex; align-items: center; margin-left: 8px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                                fill="none" stroke="#0075C9" stroke-width="1.2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314" />
                            </svg>
                        </span>
                        <input matInput placeholder="Search by applicant" [(ngModel)]="searchQuery"
                            (input)="onSearch()" />
                        <span (click)="toggleSearch()" class="cursor-pointer close-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                                <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.5"
                                    d="m8.464 15.535l7.072-7.07m-7.072 0l7.072 7.07" />
                            </svg>
                        </span>
                    </mat-form-field>
                </div>

                <button class="primaryBtn" (click)="openMedicalEvidence()">
                    <span class="btnContent">Submit Medical Evidence</span>
                </button>
            </div>
        </div>

        <div class="overview-section" [class.applyTopMargin]="showPopover">

            <div class="overview-card overdue" (click)="goToMembersTab()" (mouseenter)="onOpenRequestsHover()">
                <span class="curve-lines"><span></span></span>
                <div class="icon-title">
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
                            <path fill="currentColor"
                                d="M5.1 16c-.3-.5-.9-.6-1.4-.4c-.5.3-.6.9-.4 1.4c.3.5.9.6 1.4.4c.5-.3.6-.9.4-1.4m-.4-9.4c-.5-.2-1.1-.1-1.4.4c-.2.5-.1 1.1.4 1.4c.5.2 1.1.1 1.4-.4c.2-.5.1-1.1-.4-1.4m15.6 1.8c.5-.3.6-.9.4-1.4c-.3-.5-.9-.6-1.4-.4c-.5.3-.6.9-.4 1.4c.3.5.9.6 1.4.4M4 12c0-.6-.4-1-1-1s-1 .4-1 1s.4 1 1 1s1-.4 1-1m3.2 6.8c-.5.1-.9.7-.7 1.2c.1.5.7.9 1.2.7c.5-.1.9-.7.7-1.2c-.1-.5-.6-.8-1.2-.7M21 11c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m-.7 4.6c-.5-.3-1.1-.1-1.4.4s-.1 1.1.4 1.4s1.1.1 1.4-.4c.2-.5.1-1.1-.4-1.4M17 3.3c-.5-.3-1.1-.1-1.4.4s-.1 1.1.4 1.4s1.1.1 1.4-.4c.2-.5.1-1.1-.4-1.4m-.2 15.5c-.5-.1-1.1.2-1.2.7s.2 1.1.7 1.2s1.1-.2 1.2-.7s-.2-1-.7-1.2M12 20c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1m0-18c-.6 0-1 .4-1 1s.4 1 1 1s1-.4 1-1s-.4-1-1-1" />
                        </svg>
                    </span>
                    <span class="title">Open Requests</span>
                </div>
                <div class="count">{{dashboardData.REQUESTED || 0 | countUp:openRequestsHoverTrigger$:1000 | async}}
                </div>
                <div class="fs-12">All open requests</div>
            </div>

            <div class="overview-card incomplete" (click)="goToMembersTab()" (mouseenter)="onInProgressHover()">
                <span class="curve-lines"><span></span></span>
                <div class="icon-title">
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 1536 1792">
                            <path fill="currentColor"
                                d="M1408 128q0 261-106.5 461.5T1035 896q160 106 266.5 306.5T1408 1664h96q14 0 23 9t9 23v64q0 14-9 23t-23 9H32q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5T501 896Q341 790 234.5 589.5T128 128H32q-14 0-23-9T0 96V32Q0 18 9 9t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9zM874 836q77-29 149-92.5T1152.5 591t92.5-210t35-253H256q0 132 35 253t92.5 210T513 743.5T662 836q19 7 30.5 23.5T704 896t-11.5 36.5T662 956q-77 29-149 92.5T383.5 1201T291 1411t-35 253h1024q0-132-35-253t-92.5-210t-129.5-152.5T874 956q-19-7-30.5-23.5T832 896t11.5-36.5T874 836" />
                        </svg>
                    </span>
                    <span class="title">In Progress</span>
                </div>
                <div class="count">{{dashboardData.INPROGRESS || 0 | countUp:inProgressHoverTrigger$:1000 | async}}
                </div>
                <div class="fs-12">Currently being processed by agents</div>
            </div>

            <div class="overview-card total" (click)="goToMembersTab()" (mouseenter)="onMoreInfoRequestedHover()">
                <span class="curve-lines"><span></span></span>
                <div class="icon-title">
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 21 21">
                            <g fill="none" fill-rule="evenodd">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    d="M7.5 6.5h8m-8 3.998h5m-5 4.002h8" stroke-width="1.2" />
                                <path fill="currentColor"
                                    d="M4.499 7.5c.5 0 1-.5 1-1s-.5-1-1-1s-.999.5-.999 1s.499 1 .999 1m0 4c.5 0 1-.5 1-1s-.5-1-1-1s-.999.5-.999 1s.499 1 .999 1m0 4c.5 0 1-.5 1-1s-.5-1-1-1s-.999.5-.999 1s.499 1 .999 1" />
                            </g>
                        </svg>
                    </span>
                    <span class="title">More Info Requested</span>
                </div>
                <div class="count">{{dashboardData.MORE_INFO_REQUESTED || 0 |
                    countUp:moreInfoRequestedHoverTrigger$:1000 | async}}</div>
                <div class="fs-12">Awaiting more information from Insurer</div>
            </div>

            <div class="overview-card completed" (click)="goToMembersTab()" (mouseenter)="onCompletedRequestsHover()">
               <span class="curve-lines"><span></span></span>
                <div class="icon-title">
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 16 16">
                            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                stroke-width="1.5" d="m1.75 9.75l2.5 2.5m3.5-4l2.5-2.5m-4.5 4l2.5 2.5l6-6.5" />
                        </svg>
                    </span>
                    <span class="title">Completed Requests</span>
                </div>
                <div class="count">{{dashboardData.RECEIVED || 0 | countUp:completedRequestsHoverTrigger$:1000 | async}}
                </div>
                <div class="fs-12">Submitted medical evidence</div>
            </div>
        </div>

        <div *ngIf="isDataLoading">
            <div class="loader-pro">
                <app-loader></app-loader>
            </div>
        </div>

        <ng-container *ngIf="!isDataLoading">
            <div class="kanban-board" cdkDropListGroup>
                <div class="kanban-column animate-slide-down" *ngFor="let column of kanbanColumns" [ngClass]="getColumnClass(column.title)"
                    cdkDropList [cdkDropListData]="column.members" [cdkDropListConnectedTo]="connectedDropListsIds"
                    [id]="column.title" (cdkDropListDropped)="drop($event)">

                    <h4 class="kanban-title">
                        {{ column.title }}
                        <span class="count-badge">{{ column.members.length }}</span>
                    </h4>

                    <ng-container *ngIf="column.members.length > 0; else noDataInColumn">
                        <div *ngFor="let member of column.members" class="mb-3">
                            <app-member-card [row]="member"></app-member-card>
                        </div>
                    </ng-container>

                    <ng-template #noDataInColumn>
                        <app-no-data-found></app-no-data-found>
                    </ng-template>

                </div>
            </div>
        </ng-container>
    </div>
</div>